module.exports = __webpack_public_path__ + "assets/img/bf82-vn.svg";